import { Expose } from "class-transformer";

export class RemoveExpensesFromCertificationDto {
  @Expose()
  certificationId: string;

  @Expose()
  expenseIds: string[];
}
